<template>
  <div class="page-container">
    <!-- <div class="flex h-full"> -->
    <div class="flex h-full">
      <div style="width:100%" class="pl-20px">
        <div class="table-page-search-wrapper">
          <a-form @keyup.enter.native="searchQuery" layout="inline">
            <a-row :gutter="24">
              <!-- <j-select-device-class :multiple="false" placeholder="请选择设备类型" v-model="model.devClassId" /> -->
             <!--  <a-col :md="6" :sm="12">
                <a-form-item label="设备型号">
                  <a-select
                    :default-active-first-option="false"
                    :filter-option="false"
                    @change="handleQueryChange('devModelId')"
                    allowClear
                    placeholder="请选择设备型号"
                    show-search
                    v-model="queryParam.devModelId"
                  >
                    <a-select-option :key="d.value" v-for="d in devModelList">{{ d.text }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col> -->
              <a-col :md="6" :sm="12">
                <a-form-item label="备件名称">
                  <a-input allowClear placeholder="请输入名称关键字" v-debounce="searchQuery" v-model="queryParam.bjName" @change="handleSearchQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="8">
                <a-form-item label="厂家">
                  <a-input allowClear placeholder="请输入厂家关键字" v-debounce="searchQuery" v-model="queryParam.manuName" @change="handleSearchQuery"/>
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="8">
                <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
                  <a-button @click="handleSearchQuery" icon="search" type="primary">查询</a-button>
                  <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>

        <bpbj-standard-qt-table
          :devModelList="devModelList"
          :modelLoading="modelLoading"
          :table-fill-data="tableFillData"
          ref="m_table"
          :bpbjType = "'qt'"
          :queryParam = 'queryParam'
        />
      </div>
    </div>
    <dev-bpbj-standard-info-modal @ok="modalFormOk" ref="modalForm"></dev-bpbj-standard-info-modal>
  </div>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DevBpbjStandardInfoModal from './modules/DevBpbjStandardInfoModal'
  import '@/assets/less/TableExpand.less'
  import ClassTree from "@/views/eMaintenance/components/ClassTree.vue";
  import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
  import { mapGetters } from "vuex";

  import { getAction } from '@/api/manage';
  import BpbjStandardQtTable from '@/views/eMaintenance/components/BpbjStandardQtTable.vue'
  export default {
    name: "DevBpbjStandardInfoList",
    mixins: [JeecgListMixin],
    components: {
      DevBpbjStandardInfoModal, ClassTree, BpbjStandardQtTable
    },
    data () {
      return {
        description: '备品备件标准库管理页面',
        queryParam: { bjName: '', manuName: '', devModelId: '', projectCode: '' },
        treeCollapsed: false,
        // 表头
        columns: [
        {
            title: '备件名称',
            align: 'center',
            dataIndex: 'bjName'
          },
          {
            title: '生产厂家',
            align: 'center',
            dataIndex: 'manuName'
          },
          {
            title: '备件型号',
            align: 'center',
            dataIndex: 'bjModel'
          },
          {
            title: '备件型号规格',
            align: 'center',
            dataIndex: 'bjModelSpec'
          },
          {
            title: '单位',
            align: 'center',
            dataIndex: 'unit'
          },

          {
            title: '备件类型',
            align: 'center',
            dataIndex: 'bpbjType',
            customRender: function (text) {
              return filterDictTextByCache('bpbj_type', text)
            }
          },
          {
            title: '适配设备类型',
            align: 'center',
            dataIndex: 'devClassCode',
            customRender: function (text) {
              return '-'
            }
          },
          /* {
            title: '适配设备型号',
            align: 'center',
            dataIndex: 'unit',
            customRender: function (text) {
              return '-'
            }
          }, */
        ],
        url: {
          list: "/spareparts/devBpbjStandardInfo/list",
          delete: "/spareparts/devBpbjStandardInfo/delete",
          deleteBatch: "/spareparts/devBpbjStandardInfo/deleteBatch",
          exportXlsUrl: "/spareparts/devBpbjStandardInfo/exportXls",
          importExcelUrl: "spareparts/devBpbjStandardInfo/importExcel",

        },
        dictOptions: {},
        filterParams: '',
        superFieldList: [],
        devModelList: [],
        commonManufacturerList: [],
        tableFillData: {
          projectCode: "",
          manuName: "",
          devModelId: '',
          devClassCodes: '',
          devClassCode: ''
          // devTypeName
        },
        modelLoading: true,
        tableQueryParam: {
          devClassCodes: ''
        }
      }
    },
    created () {
      this.getSuperFieldList();
      this.loadModeList()
    },
    mounted(){
      this.handleSearchQuery()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      ...mapGetters(['username'])
    },
    methods: {
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = []
        fieldList.push({ type: 'string', value: 'bjCode', text: '备件物资编码' })
        fieldList.push({ type: 'string', value: 'bjName', text: '备件名称' })
        fieldList.push({ type: 'string', value: 'bjModel', text: '备件型号' })
        fieldList.push({ type: 'string', value: 'bjModelSpec', text: '备件型号规格' })
        fieldList.push({ type: 'string', value: 'unit', text: '单位' })
        fieldList.push({ type: 'string', value: 'devClassId', text: '设备类型' })
        fieldList.push({ type: 'string', value: 'manuId', text: '设备厂家' })
        fieldList.push({ type: 'string', value: 'devModelId', text: '设备型号' })
        fieldList.push({ type: 'int', value: 'ageMonth', text: '寿命' })
        fieldList.push({ type: 'string', value: 'ywUnit', text: '运维单位' })
        fieldList.push({ type: 'int', value: 'delFlag', text: '删除状态' })
        this.superFieldList = fieldList
      },
      treeChange (v) {
        this.filterParams = JSON.stringify({ 'dev_class_code': v })

        this.loadModeList(v)
        this.queryParam = {}
        // this.tableFillData.devClassCodes = v
        // this.tableFillData.devModelId = ''
        this.tableFillData.devClassCode = v

        const tableFillData = this.$Jlodash.clone(this.tableFillData)
        // if (Object.prototype.hasOwnProperty(tableFillData, 'devModelId')) {
        //   delete tableFillData.devModelId
        // }
        this.tableFillData = tableFillData
        this.$refs.m_table.reloadTableData({
          devClassCode: v
        })
      },
      loadModeList (code = '') {
        this.modelLoading = true
        getAction('/device/devModel/queryByDevClassId', {
          devClassCode: code
        }).then(res => {
          const result = res.result.map(item => {
            return {
              text: item.modelName,
              value: item.id,
              ...item
            }
          })

          this.devModelList = result
          this.modelLoading = false

        })
      },
      handleSearchQuery () {
        console.info('search', this.queryParam)
        this.handleQueryChange()
      },
      handleQueryChange (queryType) {

        const data = this.$Jlodash.clone(this.queryParam)
        const queryData = {
          bjName: this.queryParam?.bjName ?? '',
          manuName: this.queryParam?.manuName ?? '',
          projectCode: this.queryParam?.projectCode || ''
        }

        if (this.queryParam.devModelId) {

          const { manuName, manuId, id, modelName } = this.devModelList.find(mode => mode.value === data.devModelId)
          data.modelName = modelName
          data.devModelId = id
          data.manuId = manuId
          data.manuName = manuName
          queryData.devModelId = id
          // this.$set(this.queryParam, 'manuName', manuName)  
        } else {
          queryData.devClassCode = this.tableFillData.devClassCode
        }

        if (queryType === 'devModelId') {
          // this.tableFillData.devClassCodes = ''
          this.tableFillData.devModelId = this.queryParam.devModelId
        }
        const tableFillData = this.$Jlodash.clone(this.tableFillData)

        this.tableFillData = { ...tableFillData, ...data }

        this.$refs.m_table.reloadTableData(queryData)



      }
    }
  }
</script>
<style lang="less" scoped>
  @import '~@assets/less/common.less';

  .edit-table {
    &-collapsed {
      width: calc(100% - 50px);
    }
    &-full {
      width: calc(100% - 308px);
    }
  }
</style>
 